export { getStaticPropsMainPage } from './lib'
export { MainPage } from './ui'
export type { TPageData } from './types'
